.info {
	grid-row: 1 / 2;
	display: flex;
	flex-direction: row;
	justify-content: space-between;
}

.info > * {
	font-size: 0.9rem;
	color: var(--secondary);
}

.title {
	display: flex;
	align-items: center;
	text-align: left;
	grid-row: 2 / 3;
	background-color: var(--depth2);
	border-radius: var(--roundedBig);
	padding: 0.5rem;
	width: 100%;
	height: 100%;
	transition-duration: var(--transitionSpeedFast);
	word-break: break-word;
}

.body {
	grid-row: 3 / 4;
	width: 100%;
	height: 100%;
	padding: 0.5rem;
	background-color: var(--depth2);
	border-radius: var(--roundedBig);
	text-align: left;
	transition-duration: var(--transitionSpeedFast);
	word-break: break-word;
}

.footer {
	grid-row: 4 / 5;
	display: flex;
	flex-wrap: wrap;
	gap: 0.5rem;
}

.box {
	background-color: var(--depth1);
	transition-duration: var(--transitionSpeedFast);
	width: 100%;
	max-width: 40rem;
	height: fit-content;
	cursor: pointer;
}

.wrapper {
	border-radius: var(--roundedBig);

	height: fit-content;
	width: 100%;
	max-width: 34rem;
}

.wrapper:not(:disabled) {
	cursor: pointer;
}

.wrapper:hover .box .body {
	background-color: var(--depth3);
}
.wrapper:hover .box .title {
	background-color: var(--depth3);
}
.wrapper:disabled:hover .box {
	background-color: var(--depth1);
}
.wrapper:hover .box,
.wrapper:disabled:hover .box .title,
.wrapper:disabled:hover .box .body {
	background-color: var(--depth2);
}
